import { render, staticRenderFns } from "./SoccerHowReplyUpdatePopup.vue?vue&type=template&id=af47df1c&scoped=true&"
import script from "./SoccerHowReplyUpdatePopup.vue?vue&type=script&lang=js&"
export * from "./SoccerHowReplyUpdatePopup.vue?vue&type=script&lang=js&"
import style0 from "./SoccerHowReplyUpdatePopup.vue?vue&type=style&index=0&id=af47df1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af47df1c",
  null
  
)

export default component.exports